import React from 'react';
import './CollegeAlgebraFooter.css';

export default function CollegeAlgebraFooter() {
  return (
    <footer className="ca-footer">
      <p>College Algebra &mdash; lessons, practice quizzes, and unit tests covering UT OnRamps College Algebra (M 301 / MATH 1314).</p>
      <p className="ca-footer-disclaimer">
        This study companion follows the UT OnRamps College Algebra unit outline. It is original, independently
        written content and practice material, not affiliated with or endorsed by UT Austin or the OnRamps program.
      </p>
    </footer>
  );
}
